/** @jsxImportSource @emotion/react */
import { useTheme } from "basis";
import { EventData } from "components/Analytics/types";
import { Account } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { ReactNode } from "react";
import { useEventTracking } from "react-event-tracker";
import { Link } from "react-router-dom";

interface Props {
  href: string;
  state: { account: Account; product: Product };
  testId: string;
  eventData: EventData;
  children: ReactNode;
}

export const CardButton = ({
  href,
  state,
  testId,
  eventData,
  children,
}: Props) => {
  const theme = useTheme();
  const { trackEvent } = useEventTracking();

  return (
    <Link
      css={{
        display: "inline-block",
        width: "100%",
        textDecoration: "none",
        outline: 0,
        borderRadius: theme.radii[0],
        ...theme.focusStyles.focusVisible,
      }}
      to={href}
      state={state}
      data-testid={testId}
      onClick={() => {
        trackEvent({ event: eventData });
      }}
    >
      <div
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTop: "1px solid #e5e5e5",
          height: 50,
          ":hover": {
            backgroundColor: "#eff7ff",
          },
        }}
      >
        {children}
      </div>
    </Link>
  );
};
